import Joi from "joi";

export const updateShipmentRate = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      dollar: null,
    },
    schema: Joi.object({
      dollar: Joi.number().required().messages({
        "number.empty": joiMessage.common.required,
        "number.base": joiMessage.settings.exchange_rate.invalid,
      }),
    }),
    explicitCheck: {
      dollar: false,
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};

export const updateExhangeRate = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      dinar: null,
      RMB: null,
    },
    schema: Joi.object({
      dinar: Joi.number().required().messages({
        "number.empty": joiMessage.common.required,
        "number.base": joiMessage.settings.exchange_rate.invalid,
      }),
      RMB: Joi.number().required().messages({
        "number.empty": joiMessage.common.required,
        "number.base": joiMessage.settings.exchange_rate.invalid,
      }),
    }),
    explicitCheck: {
      dinar: false,
      RMB: false,
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};
